<template>
  <div>
    <div class="literacy-content">
      <div class="literacy-head">
        <p class="literacy-number">1</p>
        <p class="cabin-family bold">Tell us about yourself</p>
      </div>

      <div class="literacy-body">
        <div>
          <label>I am above the retirement age</label>
          <div class="form-check">
            <input class="form-check-input" value="no" v-model="retirement" type="radio"
            id="radio1">
            <label class="form-check-label"> No </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" value="yes" v-model="retirement" type="radio"
            id="radio1">
            <label class="form-check-label"> Yes </label>
          </div>
        </div>

        <div class="mt-4">
          <label>My highest level of education is</label>
          <div class="form-check">
            <input class="form-check-input" value="primary" v-model="education" type="radio"
            id="radio2">
            <label class="form-check-label"> All up to Primary</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" value="secondary" v-model="education" type="radio"
            id="radio2">
            <label class="form-check-label"> Secondary</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" value="university" v-model="education" type="radio"
            id="radio2">
            <label class="form-check-label"> University </label>
          </div>
        </div>

        <div class="mt-4">
          <label>I rely on the majority of my savings to fund my basic living expenses</label>
          <div class="form-check">
            <input class="form-check-input" value="no" v-model="savings" type="radio">
            <label class="form-check-label"> No </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" value="yes" v-model="savings" type="radio">
            <label class="form-check-label"> Yes </label>
          </div>
        </div>
      </div>

      <div class="literacy-footer">
        <button class="btn primary-btn btn-block" :disabled="isDisabled" @click="next">Next</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isDisabled() {
      if (!this.retirement || !this.education || !this.savings) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      retirement: '',
      education: '',
      savings: '',
    };
  },
  methods: {
    next() {
      const userData = {
        above_retirement: this.retirement,
        education_level: this.education,
        savings_reliance: this.savings,
      };
      this.$emit('next', userData);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>

</style>
